import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { AuthCard, AuthLayout } from "components/views/login/Shared"
import React from "react"
import L10n from "lib/carrot-l10n"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { useFormContext } from "react-hook-form"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { useSignUpFlow } from "components/context/signup/SignUpFlowContext"
import { useSignUpFindAccountSuccess } from "./context/SignUpFindAccountSuccessContext"
import styled from "styled-components"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ErrorMessage = styled.p`
  margin: 0;
  text-align: center;
  color: #d26556;
`

const EmailInput = ({ enabled }) => {
  const { register, errors } = useFormContext()
  const { email } = useSignUpFlow()
  return (
    <CompleteFormInput
      readOnly={!enabled}
      ref={register({ required: "Email is required" })}
      errors={errors}
      showValidation={false}
      defaultValue={email}
      id="email"
      name="email"
      label="Email"
      type="email"
      autoFocus
    />
  )
}

function AddEmailToAccountCard() {
  const { onSubmit, error, loading } = useSignUpFindAccountSuccess()
  return (
    <AuthCard {...{ onSubmit }}>
      <Spacer height={4} />
      <FlexRowCenter>
        <H1>{l`We found your account`}</H1>
      </FlexRowCenter>
      <Spacer height={0.5} />
      <Body color="black-80" align="tc">{l`What email address would you like to use when signing into Carrot?`}</Body>
      {error && (
        <>
          <Spacer height={0.5} />
          <ErrorMessage>{error}</ErrorMessage>
        </>
      )}
      <Spacer height={1.5} />
      <EmailInput enabled />
      <Spacer height={1.5} />
      <FlexRowCenter>
        <ButtonPrimary role="button" onClick={() => !loading && onSubmit()}>
          Sign up
        </ButtonPrimary>
      </FlexRowCenter>
      <Spacer height={2} />
    </AuthCard>
  )
}

export default function SignUpFindAccountSuccessPage() {
  return (
    <AuthLayout title="We found your account">
      <AddEmailToAccountCard />
    </AuthLayout>
  )
}
